export const CANVAS_OUTBOUND_EVENT_NAME = "pacProviderMatching.update";
